import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type NotifyContactsRequestMutationVariables = Types.Exact<{
  input: Types.NotifyContactsRequestInput;
}>;

export type NotifyContactsRequestMutation = {
  __typename?: 'Mutation';
  notifyContactsRequest?: { __typename?: 'OperationReturn'; success?: Types.OperationReturnTypeEnum | null } | null;
};

export const NotifyContactsRequestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'notifyContactsRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotifyContactsRequestInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifyContactsRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class NotifyContactsRequestGQL extends Apollo.Mutation<
  NotifyContactsRequestMutation,
  NotifyContactsRequestMutationVariables
> {
  document = NotifyContactsRequestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
